import { render } from "./expandableElement.html?vue&type=template&id=52373147&scoped=true&ts=true&external"
import script from "./expandableElement.ts?vue&type=script&lang=ts&external"
export * from "./expandableElement.ts?vue&type=script&lang=ts&external"

import "./expandableElement.scss?vue&type=style&index=0&id=52373147&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52373147"]])

export default __exports__